import * as yup from 'yup';

import i18n from '@app/i18n/config';

import { stringSchema } from '../../helpers';

const booleanSchema = yup.boolean().required(i18n.t('COMMON:errors.required'));

export const otherWorkExperienceSchema = yup
  .object({
    workDetails: yup.array().of(
      yup.object({
        companyName: stringSchema(),
        position: stringSchema(),
        startDate: yup.string().required(i18n.t('COMMON:errors.required')),
        endDate: yup.string().when('isCurrentJob', ([isCurrentJob], schema) => {
          if (isCurrentJob) return schema;
          return schema.required(i18n.t('COMMON:errors.required'));
        }),
        dismissalReason: yup
          .string()
          .when('isCurrentJob', ([isCurrentJob], schema) => {
            if (isCurrentJob) return schema;
            return schema.required(i18n.t('COMMON:errors.required'));
          }),
        isCurrentJob: booleanSchema,
      })
    ),
  })
  .required();
